import { abbreviateNumber } from 'utils/index.js';

const ONE_MINUTE_IN_SECONDS = 60;
const ONE_HOUR_IN_SECONDS = 3600;
const TIME_NOT_SPECIFIED = '-';

export const formatTime = timeInSeconds => {
  if (!timeInSeconds) {
    return TIME_NOT_SPECIFIED;
  } else if (timeInSeconds >= ONE_HOUR_IN_SECONDS) {
    const hours = Math.floor(timeInSeconds / ONE_HOUR_IN_SECONDS);
    const minutes = Math.floor((timeInSeconds - hours * ONE_HOUR_IN_SECONDS) / ONE_MINUTE_IN_SECONDS);

    if (hours >= 100) {
      return abbreviateNumber(hours);
    } else if (minutes === 0) {
      return `${hours}h`;
    }
    return `${hours}h ${minutes}m`;
  } else if (timeInSeconds >= ONE_MINUTE_IN_SECONDS) {
    const minutes = Math.floor(timeInSeconds / ONE_MINUTE_IN_SECONDS);
    const seconds = timeInSeconds - minutes * ONE_MINUTE_IN_SECONDS;

    if (seconds === 0) {
      return `${minutes}m`;
    }
    return `${minutes}m ${getPositiveOrZeroValue(seconds)}s`;
  } else {
    return `${getPositiveOrZeroValue(timeInSeconds)}s`;
  }
};

export const formatTimeColonSeparated = timeInSeconds => {
  if (!timeInSeconds) {
    return TIME_NOT_SPECIFIED;
  }

  const hours = Math.floor(timeInSeconds / ONE_HOUR_IN_SECONDS);
  const minutes = Math.floor((timeInSeconds - hours * ONE_HOUR_IN_SECONDS) / ONE_MINUTE_IN_SECONDS);
  const seconds = Math.floor((timeInSeconds - (hours * ONE_HOUR_IN_SECONDS) - (minutes * ONE_MINUTE_IN_SECONDS)));

  const paddedMinutes = `${minutes}`.padStart(2, '0');
  const paddedSeconds = `${seconds}`.padStart(2, '0');

  if (hours > 0) {
    return `${hours}:${paddedMinutes}:${paddedSeconds}`;
  }
  return `${paddedMinutes}:${paddedSeconds}`;
};

const getPositiveOrZeroValue = value => value >= 0 ? value : 0;
